import React from "react";

interface CrewChipProps {
	crew: string;
	size?: "small" | "medium" | "large";
}

export const CrewChip: React.FC<CrewChipProps> = ({
	crew,
	size = "medium",
}) => {
	const getSizeStyles = () => {
		switch (size) {
			case "small":
				return {
					padding: "2px 6px",
					fontSize: "0.75rem",
					minWidth: "20px",
					height: "20px",
				};
			case "large":
				return {
					padding: "4px 12px",
					fontSize: "0.875rem",
					minWidth: "32px",
					height: "32px",
				};
			default: // medium
				return {
					padding: "4px 8px",
					fontSize: "0.8125rem",
					minWidth: "24px",
					height: "24px",
				};
		}
	};

	const baseStyles: React.CSSProperties = {
		display: "inline-flex",
		alignItems: "center",
		justifyContent: "center",
		borderRadius: "4px",
		fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
		lineHeight: "1.5",
		cursor: "default",
		fontWeight: 800,
		...getSizeStyles(),
	};

	const getCrewStyles = (crewValue: string): React.CSSProperties => {
		switch (crewValue) {
			case "A":
				return {
					color: "rgb(255, 255, 255)",
					backgroundColor: "#B2E08A",
					border: "1px solid #B2E08A",
				};
			case "B":
				return {
					color: "rgb(236, 236, 236)",
					backgroundColor: "#E83011",
					border: "1px solid #E83011",
				};
			case "C":
				return {
					color: "rgb(255, 255, 255)",
					backgroundColor: "#3878B4",
					border: "1px solid #3878B4",
				};
			case "D":
				return {
					color: "rgb(255, 255, 255)",
					backgroundColor: "#F3A506",
					border: "1px solid #F3A506",
				};
			default:
				return {
					color: "rgb(255, 255, 255)",
					backgroundColor: "#6c757d",
					border: "1px solid #6c757d",
				};
		}
	};

	return <div style={{ ...baseStyles, ...getCrewStyles(crew) }}>{crew}</div>;
};
